module.exports = __webpack_public_path__ + "img/wk.3ff2f422.png";